import axios from "axios";

export default {
  methods: {
    /**
     * Retorna uma listagem com todos os arquivos já enviados
     * @param {Number} idRnpPrestador
     * @return {
     * [
     *    {
     *      "arquivo": "string",
     *      "baixavel": true,
     *      "dtAlteracao": "string",
     *      "dtUpload": "string",
     *      "id": 0,
     *      "status": {
     *        "chave": "PROCESSANDO",
     *        "descricao": "string"
     *      },
     *      "usuarioAlteracao": {
     *        "id": 0,
     *        "nome": "string"
     *      },
     *      "usuarioUpload": {
     *        "id": 0,
     *        "nome": "string"
     *      },
     *      "uuid": "string"
     *    }
     *  ]
     * }
     */
    getArquivosJustificativa(idRnpPrestador) {
      return axios.get(
        this.CriarUrl({
          resource: `justificativa/${idRnpPrestador}`
        })
      );
    },
    /**
     * Faz o upload do arquivo
     * @param {FormData} formData
     * @param {Number} idRnpPrestador
     */
    putUploadArquivo(formData, idRnpPrestador, onProgress) {
      return axios.put(
        this.CriarUrl({
          resource: `justificativa/upload/${idRnpPrestador}`
        }),
        formData,
        {
          onUploadProgress(progressEvent) {
            let porcentagem = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );

            if (onProgress) onProgress(porcentagem);

            return porcentagem;
          }
        }
      );
    },
    /**
     * Baixa o arquivo
     * @param {String} uuid
     */
    getDownloadArquivo(uuid) {
      return axios.get(
        this.CriarUrl({
          resource: `justificativa/download/${uuid}`
        }),
        {
          responseType: "blob"
        }
      );
    },

    /// FLUXO ANALISTA/ADM

    /**
     * Aprova a justificativa no fluxo de analista
     * @param {Number} id
     * @param {String} uuid
     */
    putAprovarJustificativa(id, uuid) {
      return axios.put(
        this.CriarUrl({
          resource: `justificativa/aprovar/${id}?uuid=${uuid}`
        })
      );
    },
    /**
     * Reprova a justificativa no fluxo de analista
     * @param {Number} id
     * @param {String} uuid
     */
    putReprovarJustificativa(id, uuid) {
      return axios.put(
        this.CriarUrl({
          resource: `justificativa/reprovar/${id}?uuid=${uuid}`
        })
      );
    }
  }
};
